import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadSymbolsEpic } from './_epics/loadSymbols.epic';

export const dictSymbolEpic = safeCombineEpics(
  loadSymbolsEpic,
);
